import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Product } from '../Product'

@InputType()
export class AutoPopulateProductMetadataArgs extends ActionArgs {
  @Field(() => ID)
  productId: string
}

export interface IAutoPopulateProductMetadata extends IAction<Product, AutoPopulateProductMetadataArgs> {}
